export enum APP_COLOR {
  DEFAULT = "#525560",
  TRANSPARENT = "transparent",
  SKY = "#08C4E3",
  WHITE = "#FFFFFF",
  BLACK = "#000000",
  BLUE = "#08C4E3",
  PURPLE = "#6658f3",
  DISABLED = "#ebecf0",
  YELLOW = "#fabc1c",
  RED = "#f84948",
  SECONDARY = "#aeb8c7",
  DARK_SECONDARY = "#444c53",
  GREEN = "#40DD7F",
  DECAY = "#FFB0AF",
}
